import * as React from 'react';
import { ILogger } from '@cian/logger';

interface IProps {
  logger: ILogger;
}

export class ErrorBound extends React.Component<IProps> {
  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { logger } = this.props;

    logger.error(error, {
      reactInfo: errorInfo.componentStack,
      message: error.message,
    });
  }

  /* Хак для того, чтобы баундари не позволял анмаунтить приложение */
  public static getDerivedStateFromError = () => {
    return {};
  };

  public render() {
    return this.props.children;
  }
}
